/** Pure list-merging helpers for useInbox: kept separate so the hook itself stays under the line budget. */

/** Later entries win (fresher data); sorted by `at` ascending, as the thread always renders. */
export const mergeMessages = (existing, incoming) => {
  const map = new Map(existing.map((m) => [m.id, m]));
  incoming.forEach((m) => map.set(m.id, m));
  return [...map.values()].sort((a, b) => new Date(a.at).getTime() - new Date(b.at).getTime());
};

/** Later entries win, first-seen position kept (a Map re-set does not move a key). */
export const mergeConversations = (existing, incoming) => {
  const map = new Map(existing.map((c) => [c.phone, c]));
  incoming.forEach((c) => map.set(c.phone, c));
  return [...map.values()];
};
